import UIComponent from "../ui/component";
import api from "../api";

export class Rating extends UIComponent {
    buttonGroups = ["main", "player", "nosub"];

    init() {
        this.currentRating = this.grade ? parseInt(this.grade) : null;

        this.includeComponents({
            DislikeModal: "document@#dislikeModal",
            player: 'document@[data-tbx-name="textPlayer"]',
            nosub: 'document@[data-tbx-name="RatingNoSub"]',
        });

        if (this.DislikeModal) {
            this.DislikeModal.setOnSubmit((comment) =>
                this.handleDislikeSubmit(comment)
            );
        }

        this.updateRating(this.currentRating);
        this.setupAllButtonHandlers();
    }

    setupAllButtonHandlers() {
        this.buttonGroups.forEach((group) => this.setupGroupHandlers(group));
    }

    setupGroupHandlers(group) {
        const likeBtn = this.getButton(group, "likeBtn");
        const dislikeBtn = this.getButton(group, "dislikeBtn");

        likeBtn?.on("click", (e) => this.handleLikeClick(e, group));
        dislikeBtn?.on("click", (e) => this.handleDislikeClick(e, group));
    }

    getButton(group, type) {
        if (group === "main") {
            return this[`${type}`];
        }
        return this[group]?.[`${type}`];
    }

    handleLikeClick(e, group) {
        e.preventDefault();
        if (this.currentRating === 1) {
            this.handleRatingRemove();
        } else {
            this.handleRating(1);
        }
    }

    handleDislikeClick(e, group) {
        e.preventDefault();
        if (this.currentRating === 0) {
            this.handleRatingRemove();
        } else {
            this.DislikeModal.show();
        }
    }

    async handleDislikeSubmit(comment) {
        if (!this.url_store) return false;

        const success = await this.sendReview(this.url_store, 0, comment || "");

        if (success) {
            this.updateRating(0);
            this.DislikeModal.hide();
            this.showRatingMessage();
        }

        return success;
    }

    async handleRating(grade) {
        if (this.currentRating === grade) return;

        const success = await this.sendReview(this.url_store, grade, "");

        if (success) {
            this.updateRating(grade);
            this.showRatingMessage();
        }
    }

    async handleRatingRemove() {
        if (!this.url_delete) return;

        try {
            const res = await api.delete(this.url_delete);
            if (res.success) {
                this.updateRating(null);
            }
        } catch (error) {
            console.error("Ошибка при удалении рейтинга", error);
        }
    }

    showRatingMessage() {
        this.parent?.ratingMessage?.show();

        if (this.messageTimeout) {
            clearTimeout(this.messageTimeout);
        }

        this.messageTimeout = setTimeout(() => {
            this.parent?.ratingMessage?.hide();
        }, 2000);
    }

    async sendReview(url, grade, comment = "") {
        try {
            const res = await api.post(url, { grade, comment });
            return res.success;
        } catch (error) {
            console.error("Ошибка при отправке отзыва", error);
            return false;
        }
    }

    updateRating(grade) {
        this.currentRating = grade;

        this.buttonGroups.forEach((group) => {
            this.updateGroupButtons(group, grade);
        });
        
        if (this.nosub) {
            if (grade === null) {
                this.nosub.removeClass("active");
            } else {
                console.log('d')
                this.nosub.addClass("active");
            }
        }
    }

    updateGroupButtons(group, grade) {
        const updateButton = (btn, isActive) => {
            if (!btn) return;

            btn.removeClass("rating-active");
            btn.removeClass("rating-inactive");

            if (grade === null) {
                btn.addClass("rating-inactive");
            } else if (grade === 1) {
                btn.addClass(isActive ? "rating-active" : "rating-inactive");
            } else if (grade === 0) {
                btn.addClass(isActive ? "rating-active" : "rating-inactive");
            }
        };

        updateButton(this.getButton(group, "likeBtn"), grade === 1);
        updateButton(this.getButton(group, "dislikeBtn"), grade === 0);
    }
}